import { Col, LoaderOverlay, Row, SideNav, SupplyPointNav } from "@emanprague/ppaskit";
import { Router } from "@frui.ts/screens";
import type { ViewComponent } from "@frui.ts/views";
import { registerView, View } from "@frui.ts/views";
import SkipNavigation from "components/SkipNavigation";
import { getSupplyPointTypeIcon, getSupplyPointTypeIconAlt } from "helpers/supplyPointHelper";
import { observer } from "mobx-react-lite";
import React from "react";
import ProductDetailViewModel from "viewModels/products/myProducts/productDetailViewModel";
import OverviewViewModel from "viewModels/supplyPoints/overviewViewModel";

const productDetailViewModel: ViewComponent<ProductDetailViewModel> = observer(({ vm }) => {
  if ((vm.activeChild as any)?.activeChild?.fullScreen) {
    return <View vm={vm.activeChild} />;
  }

  const getUrl = Router.getChildUrlFactory(vm);

  const menuItems = vm.children.map((x: any) => ({
    id: x.navigationName,
    title: x.name,
    href: getUrl(x.navigationName),
    className: x.className,
    suffix: x.suffix,
  }));

  const topNav = (
    <Row noGutters className="align-items-center pl-2 pr-3 pl-sm-0 py-2 py-md-3 mb-3">
      <Col xs={12} sm="auto" lg={12}>
        <SupplyPointNav
          currentTitle={vm.activeChild?.name}
          rootHref={vm.router.getUrl(OverviewViewModel)}
          rootTitle={vm.localization.translateGeneral("supply_points.title")}
          selectSupplyPointLabel={vm.localization.translateGeneral("supply_points.detail.choose_point")}
          supplyPointIcon={getSupplyPointTypeIcon(vm.productDetailContext.commodityType)}
          supplyPointLabel={vm.activeSupplyPointLabel}
          supplyPointIconAlt={vm.localization.translateGeneral(
            `general.${getSupplyPointTypeIconAlt(vm.productDetailContext.commodityType)}`
          )}
          supplyPoints={vm.supplyPoints}
          supplyPointsOnChange={({ target }) => vm.navigate(target.value, undefined)}
          value={vm.productDetailContext.supplyPointId}
        />
      </Col>
    </Row>
  );

  const MAIN_CONTENT_ID = "detail-content";

  const content = vm.productDetailContext.supplyPoint ? (
    <Row noGutters>
      <Col xs={12} lg="auto" className="px-3 pl-sm-0 pr-sm-3 mb-4 mb-lg-0">
        <SideNav
          links={menuItems}
          activeId={vm.activeChild?.navigationName}
          aria-label={vm.localization.translateGeneral("general.side_navigation")}
        />
      </Col>
      <Col id={MAIN_CONTENT_ID} tabIndex={-1} lg={true} className="px-3 p-sm-0 pl-lg-3 pr-lg-0">
        <View vm={vm.activeChild} />
      </Col>
    </Row>
  ) : (
    <LoaderOverlay loading variant="transparent" text={vm.localization.translateGeneral("app_loading")} />
  );

  return (
    <>
      <SkipNavigation target={MAIN_CONTENT_ID} text={vm.localization.translateGeneral("general.skip_to_content")} />
      {topNav}
      {content}
    </>
  );
});

registerView(productDetailViewModel, ProductDetailViewModel);
